import Reveal from "@/components/Reveal";

const ACHIEVEMENTS = [
  ["10+", "أدلة ودراسات وتقارير تخصصية صُممت على أساسها حلول نوعية"],
  ["40+", "جمعية احتُضنت في مسار الاستثمار الاجتماعي"],
  ["120+", "مدير تطوع مُكّنوا على أدوات مأسسة وحدات التطوع وفق معيار إدامة"],
  ["3+", "حاضنات ومسرعات لتمكين وتأهيل قدرات الأفراد والمنظمات"],
  ["25+", "مديرًا تنفيذيًا تم تأهيلهم"],
  ["4000+", "مقدم خدمة أُهّلوا لخدمة ضيوف الرحمن"],
  ["4+", "شراكات محلية ودولية مع الجهات ذات العلاقة والاختصاص"],
];

export default function Achievements() {
  return (
    <section className="bg-navy text-white py-20 sm:py-24" data-testid="achievements-section">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <Reveal>
          <span className="eyebrow">من إنجازاتنا</span>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-5 mt-4">
            <h2 className="font-display text-3xl sm:text-4xl max-w-xl leading-tight">أرقام وإحصائيات</h2>
            <p className="text-white/70 max-w-lg leading-relaxed">نتائج تعكس خبرتنا في تمكين المنظمات وبناء القدرات وإحداث الأثر.</p>
          </div>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/15 mt-10">
          {ACHIEVEMENTS.map(([value,label],i) => (
            <Reveal key={label} delay={i * 0.04}>
              <article className="bg-navy p-6 sm:p-8 min-h-44">
                <strong className="font-display text-4xl sm:text-5xl text-peach">{value}</strong>
                <p className="mt-4 text-sm sm:text-base text-white/80 leading-relaxed">{label}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
